module.exports = __webpack_public_path__ + "img/product-placeholder-20.f429b8a.png";